












import { Vue, Component, Mixins } from "vue-property-decorator";

@Component
export default class extends Mixins() {
  loading: boolean = false;

  latestUsers: any[] = [];
  async loadLatestUsers() {
    this.loading = true;
    const res = await this.$store.dispatch("statistics/latestUsers", {});
    if (res && res.Data && res.Data !== "{}") {
      this.latestUsers = res.Data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadLatestUsers();
  }
}
